import {
  getSalesStatVol,
  getSalesStatReceive,
  postSalesStatVol,
  postSalesStatReceive,
  getMySalesStatSum,
  getStatViewB,
  getStatViewC,
  addReceiveTask,
  autoSetReceiveTask,
  setReceiveTask,
  getDuiZhangDan
} from '@/api/salesStat'
import Vue from 'vue'

const state = {
  salesStatVol: [],
  volTotalCounts: 0,
  salesStatReceive: [],
  receiveTotalCounts: 0,
  salesStatSum: {},
  statViewB: [],
  statViewBCounts: 0,
  statViewC: [],
  statViewCCounts: 0,
  duizhangdan: [],
}

const getters = {}

const actions = {
  async getSalesStatVolAction({
    commit
  }, payload) {
    try {
      const res = await getSalesStatVol(payload)
      commit('SET_SALES_STAT_VOL', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
  async getMySalesStatSumAction({
    commit
  }, payload) {
    try {
      const res = await getMySalesStatSum(payload)
      commit('SET_MY_SALES_STAT_SUM', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
  async getSalesStatReceiveAction({
    commit
  }, payload) {
    try {
      const res = await getSalesStatReceive(payload)
      commit('SET_SALES_STAT_RECEIVE', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
  async getStatViewBAction({
    commit
  }, payload) {
    try {
      const res = await getStatViewB(payload)
      commit('SET_STAT_VIEW_B', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
  async getStatViewCAction({
    commit
  }, payload) {
    try {
      const res = await getStatViewC(payload)
      commit('SET_STAT_VIEW_C', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
  async postSalesStatVolAction({
    commit
  }, payload) {
    try {
      const statVol = await postSalesStatVol(payload);
      commit('POST_SALES_STAT_VOL', statVol.data)
    } catch (error) {
      throw error.message
    }
  },
  async postSalesStatReceiveAction({
    commit
  }, payload) {
    try {
      const statReceive = await postSalesStatReceive(payload);
      commit('POST_SALES_STAT_RECEIVE', statReceive.data)
    } catch (error) {
      throw error.message
    }
  },

  async updateReciveTaskAction({ commit }, payload) {
    try {
      const salesStat = await addReceiveTask(payload.id, { year: payload.year, month: payload.month, setReceiveTask: payload.setReceiveTask })
      commit('UPDATE_RECIVE_TASK', salesStat.data.salesStat)
    } catch (error) {
      throw error.message
    }
  },

  async setReceiveTaskAction({ commit }, payload) {
    try {
      const salesStat = await setReceiveTask(payload.id, payload.data)
      commit('UPDATE_RECIVE_TASK', salesStat.data.salesStat)
    } catch (error) {
      throw error.message
    }
  },

  async autoSetReceiveTaskAction({ commit }, payload) {
    try {
      const salesStat = await autoSetReceiveTask(payload)
    } catch (error) {
      throw error.message
    }
  },

  async getDuiZhangDanAction({ commit }, payload) {
    try {
      const res = await getDuiZhangDan(payload)
      commit('SET_DUIZHANGDAN', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
}

const mutations = {
  SET_SALES_STAT_VOL(state, payload) {
    state.salesStatVol = payload.salesList
    state.volTotalCounts = payload.totalCounts
  },
  SET_SALES_STAT_RECEIVE(state, payload) {
    state.salesStatReceive = payload.customerList
    state.receiveTotalCounts = payload.totalCounts
  },
  SET_MY_SALES_STAT_SUM(state, payload) {
    if (payload.length > 0) {
      state.salesStatSum = payload[0]
    } else {
      state.salesStatSum = []
    }
  },
  SET_STAT_VIEW_B(state, payload) {
    state.statViewB = payload.salesStat
    state.statViewBCounts = payload.totalCounts
  },
  SET_STAT_VIEW_C(state, payload) {
    state.statViewC = payload.salesStat
    state.statViewCCounts = payload.totalCounts
  },
  SET_DUIZHANGDAN(state, payload) {
    state.duizhangdan = payload.list
    // state.volTotalCounts = payload.totalCounts
  },
  POST_SALES_STAT_VOL(state, statVol) {
    const index = state.salesStatVol.findIndex(x => x._id === statVol.sales)
    const data = state.salesStatVol[index]
    data.salesStat.estSalesVolume = statVol.estSalesVolume
    Vue.set(state.salesStatVol, index, data)
    // Vue.set(state.salesStatVol, state.salesStatVol.findIndex(x => x._id === statVol.sales), statVol)
  },
  POST_SALES_STAT_RECEIVE(state, statVol) {
    const index = state.salesStatReceive.findIndex(x => x._id === statVol.customer)
    const data = state.salesStatReceive[index]
    data.salesStat.estReceive = statVol.estReceive
    Vue.set(state.salesStatReceive, index, data)
    // Vue.set(state.salesStatReceive, state.salesStatReceive.findIndex(x => x._id === statVol._id), statVol)
  },

  UPDATE_RECIVE_TASK(state, salesStat) {
    const index = state.statViewB.findIndex(x => x._id === salesStat._id)
    const updateStat = state.statViewB[index];
    updateStat.arTable = salesStat.arTable;
    updateStat.receiveTaskSum = salesStat.receiveTaskSum;
    Vue.set(state.statViewB, index, updateStat)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}